import { useState } from "react";

export default function Reactions({ initial = {} }) {
    const reactionsList = [
        { key: "like", label: "Like", emoji: "🙂" },
        { key: "dislike", label: "Dislike", emoji: "😐" },
        { key: "love", label: "Love", emoji: "😍" },
        { key: "funny", label: "Funny", emoji: "😂" },
        { key: "angry", label: "Angry", emoji: "😠" },
        { key: "sad", label: "Sad", emoji: "😢" },
        { key: "wow", label: "Wow", emoji: "😮" },
    ];

    const [counts, setCounts] = useState(initial);
    const [selected, setSelected] = useState(null);

    const handleReaction = (key) => {
        setSelected(key);
        setCounts((prev) => ({
            ...prev,
            [key]: (prev[key] || 0) + 1,
        }));
    };

    return (
        <div className="mt-10">
            <h2 className="text-lg font-semibold mb-4 text-gray-800">
                What’s your reaction?
            </h2>

            <div className="flex flex-wrap gap-4">

                {reactionsList.map((item) => (
                    <button
                        key={item.key}
                        onClick={() => handleReaction(item.key)}
                        className={`
              flex items-center gap-2 px-3 py-2 rounded-lg border
              transition text-sm
              ${selected === item.key
                                ? "bg-red-50 border-red-400"
                                : "bg-white border-gray-200 hover:bg-gray-50"}
            `}
                    >
                        {/* Emoji */}
                        <span className="text-2xl">{item.emoji}</span>

                        {/* Label */}
                        <span className="font-medium text-gray-700">
                            {item.label}
                        </span>

                        {/* Count */}
                        <span className="ml-1 text-xs bg-gray-200 text-gray-700 px-2 py-0.5 rounded-full">
                            {counts[item.key] || 0}
                        </span>
                    </button>
                ))}

            </div>

            <hr className="mt-8" />
        </div>
    );
}
